import Layout2 from '../components/Layout2'
import Layout3 from '../components/Layout3'
import Layout4 from '../components/Layout4'


export default x => {
  switch(x){
    case 2: return Layout2
    case 3: return Layout3
    case 4: return Layout4
    default: return Layout2
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/getLayout.js
 **/